export default __webpack_public_path__ + "static/media/servicesBack.419b951a.png";